export default __webpack_public_path__ + "static/media/lock.97cada9a.png";